export const REFERRAL_ACTION_BUTTON_CLASS =
  'h-12 shrink-0 rounded-md bg-action-button px-5 text-base leading-6 font-medium whitespace-nowrap text-white enabled:hover:bg-action-button/90 enabled:active:bg-action-button-active disabled:bg-action-button/50 disabled:opacity-100';
